import { render, staticRenderFns } from "./SliderList.vue?vue&type=template&id=9ded98c2&scoped=true"
import script from "./SliderList.vue?vue&type=script&lang=js"
export * from "./SliderList.vue?vue&type=script&lang=js"
import style0 from "./SliderList.vue?vue&type=style&index=0&id=9ded98c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ded98c2",
  null
  
)

export default component.exports